// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stock-pickup-wrap .thirty-padding {\n  padding: 0 !important;\n}\n.stock-pickup-wrap .thirty-padding .cp-lg-obj-wrap {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
